import React from 'react'
import { BaseModal } from './BaseModal'
// add GameStats import only if it's not already imported where ToonModal lives
import { GameStats } from '../../lib/localStorage'

type Props = {
  isOpen: boolean
  handleClose: () => void

  // legacy props (kept optional so existing callers compile)
  guesses?: string[]
  gameStats?: GameStats
  submitted?: string
  isGameLost?: boolean
  isGameWon?: boolean
  handleShare?: () => any
  handleStats?: () => any
  handleCarousel?: () => any
  handleSubmit?: () => any
}


/**
 * Simple notice: contest closed.
 * - No exports, no captions, no stats or share buttons.
 * - Just an image + text.
 */
export const ToonModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal
      title="Warpt Comic Weekly Caption Contest"
      isOpen={isOpen}
      handleClose={handleClose}
    >
      <div className="space-y-3">
        <img
          src="/toons/error.jpg"
          alt="Contest closed"
          className="w-full rounded-md border-4 border-stone-200 bg-stone-200"
          onError={({ currentTarget }) => {
            // if even the error image fails, keep the bg and border so it doesn't look broken
            currentTarget.onerror = null
          }}
        />
		<p className="text-sm text-gray-800 dark:text-gray-100">
		The weekly Warpt Comic Caption Contest is closed.  
		Check out our{' '}
		<a
			href="https://discord.gg/xRSQSTNW6d"
			target="_blank"
			rel="noopener noreferrer"
			className="text-indigo-600 hover:underline"
		>
			Discord
		</a>{' '}
		for more fun and updates!
		</p>

      </div>
    </BaseModal>
  )
}
